<template>
  <div>
    <div class="page-title">Edit Image Asset</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btn-text="Update Image Asset"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.image-assets.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.ImageAsset.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.ImageAsset.update(this.form);
      this.$router.push("/dev-tools/image-library");
    },
  },
};
</script>

<style></style>
